// Message code define



// Endpoint
export const ActivityEngagementEndPoint = {
  GET: 'admin/activity-engagement/list',
  CREATE: 'admin/activity-engagement/create',
  DETAIL: 'admin/activity-engagement/by-id',
  UPDATE: 'admin/activity-engagement/update',
  DELETE: 'admin/activity-engagement/delete',
  TOTAL: 'admin/activity-engagement/count',
}